export default __webpack_public_path__ + "static/0076-3461a4492d3c067afb272ab7bce67053.png";